import {
  Article,
  ArticleImage,
  ArticleSubtitle,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import { useLocalizeLineItem } from "../hooks/use-localize-line-item";
import { getLineItemDisplay } from "../utils/line-item-display";
import type { DraftLineItem, OrderLineItem } from "../types";

type Props = {
  item: DraftLineItem;
  orderLineItems: OrderLineItem[];
};

export function RetractationSummaryLineItem({ item, orderLineItems }: Props) {
  const localize = useLocalizeLineItem();
  const { title, subtitle, image } = getLineItemDisplay(
    orderLineItems.map(localize),
    item.lineItemId,
  );

  return (
    <Article>
      <ArticleImage src={image ?? undefined} layoutId={`img-${item.lineItemId}`} />
      <ArticleTitle>{title}</ArticleTitle>
      {subtitle ? (
        <ArticleSubtitle>{subtitle} — ×{item.quantity}</ArticleSubtitle>
      ) : (
        <ArticleSubtitle>×{item.quantity}</ArticleSubtitle>
      )}
    </Article>
  );
}
